import { z } from 'zod';
import {
  CLIENT_IMAGE_META_ANALYSIS_VERSION,
  CLIENT_IMAGE_META_DIRECT_TRUST_FIELDS,
  CLIENT_IMAGE_META_FIELDS,
  isClientImageMetaDirectTrustField,
} from './client-meta-constants';
import {
  type ImageRuntimeMeta,
  imageRuntimeMetaSchema,
  projectImageRuntimeMeta,
} from './image-runtime-meta';

export {
  CLIENT_IMAGE_META_ANALYSIS_VERSION,
  CLIENT_IMAGE_META_DIRECT_TRUST_FIELDS,
  CLIENT_IMAGE_META_FIELDS,
  isClientImageMetaDirectTrustField,
};

export const clientImageMetaSchema = imageRuntimeMetaSchema
  .extend({
    analysisVersion: z.literal(CLIENT_IMAGE_META_ANALYSIS_VERSION),
  })
  .strict();

export type ClientImageMeta = z.infer<typeof clientImageMetaSchema>;
export type ClientImageMetaField = (typeof CLIENT_IMAGE_META_FIELDS)[number];

// 白名单能力的唯一投影入口：后端直信任路径只接收宽度、高度、格式和透明度，
// 不把客户端元数据版本等未列入白名单的字段带入这条运行依据链路。
export function projectClientImageMetaForDirectTrust(
  meta: ClientImageMeta
): ImageRuntimeMeta {
  return projectImageRuntimeMeta(meta);
}

export function parseClientImageMeta(
  value: unknown
): { ok: true; data: ClientImageMeta } | { ok: false; issues: string[] } {
  const parsed = clientImageMetaSchema.safeParse(value);
  if (parsed.success) {
    return { ok: true, data: parsed.data };
  }

  return {
    ok: false,
    issues: parsed.error.issues.map((issue) => {
      const path = issue.path.join('.');
      return path ? `${path}: ${issue.message}` : issue.message;
    }),
  };
}
